import { useStore } from "@store/index"

export const useInsightsCollection = (articleId: string) => {
  const { expertInsightsStore } = useStore()
  return expertInsightsStore.articleInsightsStore.getCollection(articleId)
}

export default useInsightsCollection
